//
//
//
//
//
//

export default {
  name: 'HollowDotsSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    dotSize: {
      type: Number,
      default: 15
    },
    dotsNum: {
      type: Number,
      default: 3
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    horizontalMargin () {
      return this.dotSize / 2
    },

    spinnerStyle () {
      return {
        height: `${this.dotSize}px`,
        width: `${(this.dotSize + this.horizontalMargin * 2) * this.dotsNum}px`
      }
    },

    dotStyle () {
      return {
        animationDuration: `${this.animationDuration}ms`,
        width: `${this.dotSize}px`,
        height: `${this.dotSize}px`,
        margin: `0 ${this.horizontalMargin}px`,
        borderWidth: `${this.dotSize / 5}px`,
        borderColor: this.color
      }
    },

    dotsStyles () {
      const dotsStyles = []
      const delayModifier = 0.3
      const basicDelay = 1000

      for (let i = 1; i <= this.dotsNum; i++) {
        const style = Object.assign({
          animationDelay: `${basicDelay * i * delayModifier}ms`
        }, this.dotStyle)

        dotsStyles.push(style)
      }

      return dotsStyles
    }
  }
}
